import { createSlice } from '@reduxjs/toolkit';
import type { PathwaySharedViewerState } from './types';

const initialState: PathwaySharedViewerState = {
  isLoading: false,
  error: false,
  pathway: null,
  topics: [],
  hasMore: false
};

export const slice = createSlice({
  name: 'pathwaySharedViewer',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getPathwaySuccess(state, action) {
      state.isLoading = false;
      state.pathway = action.payload;
    },
    cleanPathway(state) {
      state.isLoading = false;
      state.error = false;
      state.topics = [];
      state.pathway = null;
      state.hasMore = false;
    }
  }
});

// Reducer
export default slice.reducer;
